var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.906,
    height: 24,
    viewBox: "0 0 19.906 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-solid_1_",
    "data-name": "user-solid (1)",
    d: "M9.953,12a5.85,5.85,0,0,0,5.687-6A5.85,5.85,0,0,0,9.953,0,5.85,5.85,0,0,0,4.266,6,5.85,5.85,0,0,0,9.953,12ZM7.923,14.25A8.147,8.147,0,0,0,0,22.608,1.358,1.358,0,0,0,1.32,24H18.587a1.358,1.358,0,0,0,1.32-1.392,8.147,8.147,0,0,0-7.923-8.358Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWhite);
export default __webpack_public_path__ + "static/media/user-white.be2b245435e2742fba4fdd59dd2d2086.svg";
export { ForwardRef as ReactComponent };